<template>
  <v-row class="address-card ml-1" justify="start" test-id="transaction-entry-data-card">
    <v-col class="text-center pa-0 align-content-center" cols="2" md="1"
      style="border-right: 1px solid var(--card-border)">
      <v-list-item-avatar>
        <v-icon test-id="icon-entry-data-card" size="42">  {{ entryIcon }} </v-icon>
      </v-list-item-avatar>
    </v-col>
    <v-col class="pl-4">
      <v-row v-if="transactionModel != 'standard'">
        <v-col class="pa-0 col-sm-4 col-5">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title test-id="title-name-entry-data-card" class="font-weight-medium">
                {{ $vuetify.lang.t("$vuetify.name") }}
              </v-list-item-title>
              <v-list-item-subtitle test-id="subtitle-name-entry-data-card" class="subtitle">
                {{ transaction_content.recipient_data.contact_name }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col class="pa-0 d-none d-md-block" cols="6" sm="7">
          <v-list-item>
              <v-list-item-content>
                <v-list-item-title test-id="title-address-entry-data-card" class="font-weight-medium">
                  {{ hasPostalAddress ? $vuetify.lang.t("$vuetify.address") : $vuetify.lang.t("$vuetify.emailSubject")
                  }}
                </v-list-item-title>
                <v-list-item-subtitle test-id="subtitle-address-entry-data-card" class="subtitle">
                  {{ getSubtitle() }}
                </v-list-item-subtitle>
              </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
      <!-- Transaction Details Standard -->
      <v-row dense v-else>
        <v-col cols="12" md="6" class="cts-transaction-contact">
          <v-row v-for="(value, key) in transaction_recipient_data" :key="key" class="ma-0 pa-0 " dense>
            <v-col class="px-0 py-0 " cols="12">
              <span class="font-weight-bold mr-2">
                {{ $vuetify.lang.t('$vuetify.' + key) }}:
              </span>
              <span v-if="!value || value === '' ||
                (value.indexOf('+') !== -1 && value.replace(' ', '').length === 3)">
                {{ $vuetify.lang.t('$vuetify.notInformed') }}
              </span>
              <span v-else>
                <a v-if="key === const_global.CONTACT_PHONE" :href="'tel:' + value" class="cts-link">
                  {{ value }}
                </a>
                <span v-else>{{ value }}</span>
              </span>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="6">
          <v-row v-for="(parameter, index) in filteredTransactionParameters" :key="index"
            class="ma-0 pa-0 cts-transaction-state" dense>
            <v-col class="px-0 py-0" cols="12" lg="12" md="12" sm="12" xl="12">
              <span class="font-weight-bold mr-2">{{ getParameterLabel(parameter) }}:</span>
              <span class="cts-transaction-state-value">{{
                parameter.value
              }}</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import { capitalize } from "@/util/utils";
import const_global from "@/constants/global";
import dayjs from "@/plugins/dayjs";
export default {
  name: "TransactionEntryDataCard",
  data() {
    return {
      const_global,
      dayjs,
    };
  },
  props: {
    transaction_content: Object,
    filteredTransactionParameters: Array,
    transactionModel: String,
    transaction_recipient_data: Object,
  },
  computed: {
    entryIcon() {
    return this.transactionModel !== 'standard'
      ? 'mdi-map-marker-radius-outline'
      : 'mdi-information-outline';
    },
    hasPostalAddress() {
      return this.filteredTransactionParameters.some(p => p.key === 'postal_address');
    },
    fullAddress() {
      const getValue = (key) => {
        const found = this.filteredTransactionParameters.find(p => p.key === key);
        return found ? found.value : '';
      };
      return [
        getValue('postal_address'),
        getValue('city'),
        getValue('province'),
        getValue('zip_code')
      ].filter(Boolean).join(', ');
    }
  },
  methods: {
    capitalize,
    getSubtitle() {
      if (this.hasPostalAddress) {
        return this.fullAddress || this.$vuetify.lang.t("$vuetify.notAvailable");
      }
      const found = this.filteredTransactionParameters.find(param => param.key === 'email_subject');
      return found && found.value ? found.value : this.$vuetify.lang.t("$vuetify.notAvailable");
    },
    getParameterLabel(parameter) {
      return parameter.translation ? parameter.translation : parameter.key;
    },
  }
}
</script>

<style lang="scss" scoped>
.address-card {
  width: 100%;
  box-sizing: border-box;
  border: solid 1px var(--card-border);
  min-height: 60px;
  align-content: space-evenly;
  border-radius: 4px;
  margin-bottom: 8px;

  .col {
    height: fit-content;
    margin: auto 0;
  }

  .v-list-item__title,
  .v-list-item__subtitle {
    font-size: 0.9rem;
  }

  .icon {
    min-width: 50px !important;
  }

  .v-list-item__avatar {
    margin-right: 0 !important;
  }

  .v-list-item {
    padding: 0;

    .v-list-item__content {
      padding: 0;
      padding-left: 4px;
    }
  }

  .subtitle {
    white-space: normal;
    word-break: break-word;
  }

  @media (max-width: 600px) {
    .subtitle {
      display: block;
      max-width: 100%;
    }
  }
}
</style>
